import React from "react";
import { WORKFLOX, workfloxPosts } from "../../data/workflox";
import { ArrowIcon, Mask, WorkfloxLink } from "./Chrome";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
// "2026-09-22" → "22 Sep 2026", without Date's timezone shifts
const formatDate = (iso) => {
  const [year, month, day] = iso.split("-").map(Number);
  return `${day} ${MONTHS[month - 1]} ${year}`;
};

// Articles are published on workflox.net; every card opens the post there
function Insights() {
  return (
    <section id="blog" className="section">
      <div className="wrap">
        <div className="insights-head">
          <div>
            <p className="eyebrow">Insights</p>
            <h2 className="section-title">
              <Mask>
                Notes for <em>founders</em>
              </Mask>
            </h2>
          </div>
          <WorkfloxLink href={`${WORKFLOX}/blog`} className="btn">
            All articles on workflox.net <ArrowIcon />
          </WorkfloxLink>
        </div>

        <div className="post-grid">
          {workfloxPosts.map((post) => (
            <WorkfloxLink key={post.slug} href={post.url} className="post" data-reveal>
              <div className="post-cover">{post.image && <img src={post.image} alt="" loading="lazy" />}</div>
              <div className="post-body">
                <span className="post-cat">
                  {post.category} · <time dateTime={post.date}>{formatDate(post.date)}</time>
                </span>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <span className="post-more">
                  Read on workflox.net <ArrowIcon />
                </span>
              </div>
            </WorkfloxLink>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Insights;
